const DEFAULT_DIGITS = 2;
const MIN_DIGITS = 0;

const addLeadingZeroUtil = (value: number, digits = DEFAULT_DIGITS): string => {
  if (digits <= MIN_DIGITS || isNaN(value) || typeof value !== 'number') {
    return '';
  }

  const valueString = value.toString();
  const valueLength = valueString.length;
  const leadingZeroLength = digits - valueLength;

  if (leadingZeroLength <= MIN_DIGITS) {
    return value.toString();
  }

  const leadingZero = '0'.repeat(leadingZeroLength);

  return `${leadingZero}${valueString}`;
};

export default addLeadingZeroUtil;
